'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _saveSearch = require('./remote/saveSearch');

var SaveSearch = {
    deleteSavedSearch: function deleteSavedSearch(params) {
        return _saveSearch.SaveSearchRemote.deleteSavedSearch(params);
    },
    fetchSavedSearches: function fetchSavedSearches(params) {
        return _saveSearch.SaveSearchRemote.fetchSavedSearches(params);
    },
    fetchSavedSearchItems: function fetchSavedSearchItems(params) {
        return _saveSearch.SaveSearchRemote.fetchSavedSearchItems(params);
    },
    postDeleteSavedSearches: function postDeleteSavedSearches(params) {
        return _saveSearch.SaveSearchRemote.postDeleteSavedSearches(params);
    },
    postIsSavedSearch: function postIsSavedSearch(params) {
        return _saveSearch.SaveSearchRemote.postIsSavedSearch(params);
    },
    postSaveSearch: function postSaveSearch(params) {
        return _saveSearch.SaveSearchRemote.postSaveSearch(params);
    },
    postSubscribeToSavedSearches: function postSubscribeToSavedSearches(params) {
        return _saveSearch.SaveSearchRemote.postSubscribeToSavedSearches(params);
    },
    postUnsubscribeFromSavedSearches: function postUnsubscribeFromSavedSearches(params) {
        return _saveSearch.SaveSearchRemote.postUnsubscribeFromSavedSearches(params);
    }
};

exports.default = SaveSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/saveSearch.js
// module id = Ykd8
// module chunks = 46